import React, { useEffect } from "react";

import GlobalContextProvider from "../../Contexts/GlobalContextProvider";

const setCSSVariable = (varName, varValue) => {
  document.documentElement.style.setProperty(varName, varValue);
};

const NoLayoutContent = (props) => {
  useEffect(() => {
    setCSSVariable("--primary-color", window.REACT_APP_COLOR);
    setCSSVariable("--fiscal-alert", window.REACT_APP_ALERT_COLOR);
  }, []);

  return (
    <>
      <GlobalContextProvider>{props.children}</GlobalContextProvider>
    </>
  );
};

export default NoLayoutContent;
